import { render, staticRenderFns } from "./ContractAccelerators.vue?vue&type=template&id=2fba1734&scoped=true"
import script from "./ContractAccelerators.vue?vue&type=script&lang=js"
export * from "./ContractAccelerators.vue?vue&type=script&lang=js"
import style0 from "./ContractAccelerators.vue?vue&type=style&index=0&id=2fba1734&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fba1734",
  null
  
)

export default component.exports